import { Icon, IconProps } from "@chakra-ui/react";

// Shared line-art treatment: one stroke weight across both marks so they read as a pair.
const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function StarshipIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 64 64" {...props}>
      <g {...strokeProps}>
        {/* Nosecone and body */}
        <path d="M32 4c-4.2 5.6-6.4 12-6.4 18.6v25.6h12.8V22.6C38.4 16 36.2 9.6 32 4z" />
        {/* Forward flaps */}
        <path d="M25.6 20.4l-5.6 3.4v9.4l5.6-3.2" />
        <path d="M38.4 20.4l5.6 3.4v9.4l-5.6-3.2" />
        {/* Aft flaps */}
        <path d="M25.6 38.8l-7.4 4.4v9.6l7.4-4.2" />
        <path d="M38.4 38.8l7.4 4.4v9.6l-7.4-4.2" />
        {/* Engine skirt */}
        <path d="M25.6 48.2h12.8l2 5.4H23.6z" />
        {/* Exhaust */}
        <path d="M28 57.2v3M32 57.6v4M36 57.2v3" />
      </g>
    </Icon>
  );
}

export function CapsuleIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 64 64" {...props}>
      <g {...strokeProps}>
        {/* Blunt-cone reentry vehicle */}
        <path d="M26 14h12l8 26H18z" />
        {/* Heat shield */}
        <path d="M18 40h28l-3.2 5.6H21.2z" />
        {/* Shoulder and hatch detail */}
        <path d="M23.4 26h17.2" />
        <circle cx="32" cy="20.4" r="3.2" />
        {/* Reentry plasma arcs */}
        <path d="M15.4 52.6c5-3.4 28.2-3.4 33.2 0" />
        <path d="M20 58.4c3.6-2.4 20.4-2.4 24 0" />
      </g>
    </Icon>
  );
}
